module.exports = __webpack_public_path__ + "static/media/sneakpeek-message-icon.db03f0dd.png";